// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { useModalContext } from 'components'

const Header = ({ idRoot }) => {
  const { closeContextModal } = useModalContext()

  return (
    <h4 className={'database-details-modal-heading bg-blue-dark padding-left-half padding-right-half uppercase display-flex justify-content-between align-items-center'}>
      <i className={'fa fa-comment-o'} />
      <strong
        id={`${idRoot}-new-comment-modal-heading`}
        style={{ marginRight: 'auto' }}>
        {'Add Comment'}
      </strong>
      <span
        id={`${idRoot}-new-comment-modal-close`}
        onClick={closeContextModal}>
        {'X'}
      </span>
    </h4>
  )
}

Header.propTypes = {
  idRoot: string.isRequired,
}

export default Header
